import { type BlokProps, StoryblokComponentList } from "@trydig/storyblok";
import type { BlokManualSection } from "@/storyblok";
import BlokWrap from "../../BlokWrap";
import styles from "./ManualSectionBlok.module.css";

export const ManualSectionBlok = ({
	blok,
	preview,
}: BlokProps<BlokManualSection>) => {
	return (
		<BlokWrap editable={blok} className={styles.root}>
			<span className={styles.title}>{blok.title}</span>
			<div className={styles.manuals}>
				{blok.items && (
					<StoryblokComponentList bloks={blok.items} preview={preview} />
				)}
			</div>
		</BlokWrap>
	);
};
